module.exports = __webpack_public_path__ + "img/additionalproduct_charge_logo.75979f75.png";